import type { Feature } from './types';

import { getEnvValue } from '../utils';

// BounceBit 验证者功能配置
const title = 'BounceBit Validators';

type ValidatorsBounceBitConfig = {
  validatorContractAddress: string;
  stakingContractAddress: string;
};

const config: Feature<ValidatorsBounceBitConfig> = (() => {
  const validatorContractAddress = getEnvValue('NEXT_PUBLIC_VALIDATOR_CONTRACT_ADDRESS');
  const stakingContractAddress = getEnvValue('NEXT_PUBLIC_STAKING_CONTRACT_ADDRESS');

  if (validatorContractAddress && stakingContractAddress) {
    return Object.freeze({
      title,
      isEnabled: true,
      validatorContractAddress,
      stakingContractAddress,
    });
  }

  return Object.freeze({
    title,
    isEnabled: true,
    validatorContractAddress: '',
    stakingContractAddress: '',
  });
})();

export default config;
